import { createElement, FC } from 'react';

import { CurrentStakeType } from '../../types';

import { StakeType } from 'app/lib/staking/constants';

import StakeTypeExpress from './Express';
import StakeTypeSingle from './Single';
import StakeTypeSystem from './System';

// ---

type FooterStakeTypeProps = {
  stakeType: CurrentStakeType;
};

const FooterStakeType: FC<FooterStakeTypeProps> = ({ stakeType }) => {
  if (stakeType.has(StakeType.SINGLE)) {
    return createElement(StakeTypeSingle);
  }

  if (stakeType.has(StakeType.EXPRESS)) {
    return createElement(StakeTypeExpress);
  }

  if (stakeType.has(StakeType.SYSTEM)) {
    return createElement(StakeTypeSystem);
  }

  console.error(`getFooterStakeTypeComponent -> unrecognized stake type "${stakeType?.toJS()}"`);
  return null;
};

export default FooterStakeType;
